import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IRankingBreakdown, defaultValue } from '../../model/ranking-breakdown.model';

export const ACTION_TYPES = {
  FETCH_RANKINGBREAKDOWN_LIST: 'rankingBreakdown/FETCH_RANKINGBREAKDOWN_LIST',
  FETCH_RANKINGBREAKDOWN: 'rankingBreakdown/FETCH_RANKINGBREAKDOWN',
  CREATE_RANKINGBREAKDOWN: 'rankingBreakdown/CREATE_RANKINGBREAKDOWN',
  UPDATE_RANKINGBREAKDOWN: 'rankingBreakdown/UPDATE_RANKINGBREAKDOWN',
  DELETE_RANKINGBREAKDOWN: 'rankingBreakdown/DELETE_RANKINGBREAKDOWN',
  RESET: 'rankingBreakdown/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IRankingBreakdown>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type RankingBreakdownState = Readonly<typeof initialState>;

// Reducer

export default (state: RankingBreakdownState = initialState, action): RankingBreakdownState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_RANKINGBREAKDOWN_LIST):
    case REQUEST(ACTION_TYPES.FETCH_RANKINGBREAKDOWN):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_RANKINGBREAKDOWN):
    case REQUEST(ACTION_TYPES.UPDATE_RANKINGBREAKDOWN):
    case REQUEST(ACTION_TYPES.DELETE_RANKINGBREAKDOWN):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_RANKINGBREAKDOWN_LIST):
    case FAILURE(ACTION_TYPES.FETCH_RANKINGBREAKDOWN):
    case FAILURE(ACTION_TYPES.CREATE_RANKINGBREAKDOWN):
    case FAILURE(ACTION_TYPES.UPDATE_RANKINGBREAKDOWN):
    case FAILURE(ACTION_TYPES.DELETE_RANKINGBREAKDOWN):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_RANKINGBREAKDOWN_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_RANKINGBREAKDOWN):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_RANKINGBREAKDOWN):
    case SUCCESS(ACTION_TYPES.UPDATE_RANKINGBREAKDOWN):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_RANKINGBREAKDOWN):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/ranking-breakdowns';

// Actions

export const getEntities: ICrudGetAllAction<IRankingBreakdown> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_RANKINGBREAKDOWN_LIST,
    payload: axios.get<IRankingBreakdown>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IRankingBreakdown> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_RANKINGBREAKDOWN,
    payload: axios.get<IRankingBreakdown>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IRankingBreakdown> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_RANKINGBREAKDOWN,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IRankingBreakdown> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_RANKINGBREAKDOWN,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IRankingBreakdown> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_RANKINGBREAKDOWN,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
